import { render, staticRenderFns } from "./extra-password-reset.vue?vue&type=template&id=21ab20b3&scoped=true&lang=pug&"
import script from "./extra-password-reset.vue?vue&type=script&lang=js&"
export * from "./extra-password-reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab20b3",
  null
  
)

export default component.exports